import React, { useEffect, useRef } from 'react';
import ResizableField from '../../../utility/resizableField';
import _ from 'lodash';
import { GridYValue } from '../../../constants';

export const FileUploadElement = function FromElement({ element, setPosition, innerElemHeight }) {
  const inputRef = useRef();

  const handlerWidthChange = (shift) => {
    var formAreaWidth = document.getElementsByClassName('form-area')[0].offsetWidth;

    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        width: Math.max(
          5,
          Math.min(100 - prevPosition.left, Math.floor((((prevPosition.startWidth / 100) * formAreaWidth + shift) / formAreaWidth) * 100)),
        ),
      };
    });
  };

  const finishWidthChange = () => {
    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        startWidth: prevPosition.width,
      };
    });
  };

  const handlerHeightChange = (shift) => {
    setPosition((prevPosition) => {
      const diff = Math.floor(shift / GridYValue);

      return {
        ...prevPosition,
        height: Math.max(17, prevPosition.startHeight + diff),
        innerElemHeight: Math.max(7, prevPosition.startInnerElemHeight + diff),
      };
    });
  };

  const finishHeightChange = () => {
    setPosition((prevPosition) => {
      return {
        ...prevPosition,
        startHeight: prevPosition.height,
        startInnerElemHeight: prevPosition.innerElemHeight,
      };
    });
  };

  useEffect(() => {
    ResizableField(inputRef.current, handlerWidthChange, finishWidthChange, handlerHeightChange, finishHeightChange);
  }, [inputRef, element, element.options.width]);

  return (
    <>
      <label htmlFor={element.id} className="form-label">
        {element.options.label} <span className="required">{element.options.requiredFor ? '*' : ''}</span>
      </label>
      <div className="d-flex input-resizable-wrapper flex-wrap" style={{ height: innerElemHeight }}>
        <div
          className={`form-control-file form-control-file-default form-control-${element.options.size}`}
          ref={inputRef}
          style={{
            width: '100%',
            height: innerElemHeight,
            minHeight: 'unset',
          }}
        >
          <input accept={element.options.fileType?.map((item) => item.value)} name={element.options.name} id={element.id} />
          <div>
            <img className="icon-icon-upload" src="/images/upload-svg.svg" alt="" />
            <span>Click to upload</span>
            <span className="sub-text">{element.options.fileType?.map((item) => item.value)}</span>
          </div>
        </div>
      </div>
      <p className="text-secondary mt-1">No files uploaded yet</p>
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </>
  );
};
